import { render } from "./UnsubmittedLiquidations.vue?vue&type=template&id=c4326c4a"
import script from "./UnsubmittedLiquidations.vue?vue&type=script&lang=js"
export * from "./UnsubmittedLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__